export default __webpack_public_path__ + "static/media/cacti.52c69cb71fc6a359889db61d0eb4ad0b.png";